enum ScheduleBlockStatus {
    STATUS_SCHEDULED = "SCHEDULED",
    STATUS_IN_PROGRESS = "IN_PROGRESS",
    STATUS_COMPLETE = "COMPLETE",
    STATUS_CANCELLED = "CANCELLED",
}

export default ScheduleBlockStatus;
